/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileBmp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M9.778 11.983c.64 0 1.11.108 1.409.325.303.216.455.552.455 1.007 0 .336-.127.617-.38.842-.087.076-.185.14-.292.195.193.06.355.144.485.253.267.217.4.525.4.925 0 .492-.168.861-.503 1.105-.336.243-.847.365-1.532.365h-1.8v-5.017zm-.724 4.189h.683c.354 0 .614-.055.78-.165.165-.11.249-.283.249-.518 0-.23-.084-.398-.25-.504s-.425-.159-.779-.159h-.683zm0-2.111h.524c.364 0 .62-.046.767-.138.151-.097.227-.258.227-.483a.64.64 0 0 0-.096-.373c-.06-.092-.164-.158-.311-.2a2.19 2.19 0 0 0-.587-.062h-.524zm6.193 1.227 1.571-3.305h1.125V17h-1.062v-3.249l-1.325 2.766h-.662l-1.326-2.723V17h-1.04v-5.017h1.123zm5.469-3.305c.616 0 1.08.143 1.393.428.318.285.477.709.477 1.27 0 .372-.072.685-.215.938a1.325 1.325 0 0 1-.627.566c-.276.13-.619.194-1.028.194h-.725V17h-1.07v-5.017zm-.725 2.519h.504c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.235-.635-.151-.124-.411-.186-.779-.186h-.504z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileBmp as FileBmp };
